let exitModalShown = false;
export const showModal = (modal) => {
    toggleModal(modal, true);
};
export const hideModal = (modal) => {
    toggleModal(modal, false);
};
export const showExitModal = () => {
    if (exitModalShown) {
        return;
    }
    const exitModal = document.querySelector('.modal[data-identifier="exit"]');
    if (exitModal) {
        hideAllModals();
        showModal(exitModal);
        exitModalShown = true;
        return;
    }
};
const toggleModal = (modal, active) => {
    const overlay = document.getElementById('modals__overlay');
    if (overlay) {
        overlay.classList.toggle('is-open', active);
    }
    modal.classList.toggle('is-open', active);
};
export const hideAllModals = () => {
    const overlay = document.getElementById('modals__overlay');
    if (overlay) {
        overlay.classList.toggle('is-open', false);
    }
    const modals = document.querySelectorAll('.modal');
    modals.forEach((modal) => modal.classList.remove('is-open'));
};
export const initModals = () => {
    const modals = document.querySelectorAll('.modal');
    modals.forEach((modal) => {
        const closeButton = modal.querySelector('.modal__close');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                hideModal(modal);
            });
        }
        const identifier = modal.dataset.identifier;
        if (!identifier) {
            return;
        }
        const linksToModal = document.querySelectorAll(`a[href$="#${identifier}"]`);
        linksToModal.forEach((link) => link.addEventListener('click', (event) => {
            showModal(modal);
            event.preventDefault();
        }));
    });
    const closeTriggers = document.querySelectorAll('.modal-close-trigger, #modals__overlay');
    closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => hideAllModals());
    });
};
